import React, { type FC, type ReactNode } from 'react'
import { Paper, type SxProps, type Theme } from '@mui/material'

import type { Translation } from '../../../../domain'

import { AnchorProvider, Button, Popover, useAnchorCloser, useAnchorSetter } from '../../common'
import { FormattedTranslation } from '../../Internationalization'
import { extractDataTestId } from '../../utils'

const buttonStyle: SxProps<Theme> = {
    ml: 0.5,
    borderRadius: 2,
    borderColor: 'black',
    color: 'black',
    '&:hover': { borderColor: 'black', backgroundColor: 'unset' },
}
const popoverStyle: SxProps<Theme> = { p: 1 }

type Props = Readonly<{ startIcon: ReactNode, text: Translation, popover: ReactNode }>

const InnerPopoverButton: FC<Props> = ({ startIcon, text, popover, ...props }) => {
    const setOrigin = useAnchorSetter()
    const close = useAnchorCloser()

    return (
        <>
            <Button
                startIcon={startIcon}
                data-testid={extractDataTestId(props, 'Button')}
                variant="secondary"
                sx={buttonStyle}
                onClick={(e) => setOrigin(e.currentTarget)}
            >
                <FormattedTranslation id={text} />
            </Button>
            <Popover
                data-testid={extractDataTestId(props, 'Popover')}
                onClose={close}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                transformOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Paper sx={popoverStyle}>{popover}</Paper>
            </Popover>
        </>
    )
}

export const PopoverButton: FC<Props> = (props) => (
    <AnchorProvider>
        <InnerPopoverButton {...props} />
    </AnchorProvider>
)
